// تأثيرات سحرية لموقع وِداد
import React, { useState, useEffect } from 'react';

// 🎉 تأثير الاحتفال (Confetti) - يُستخدم عند النجاح
export const Confetti = ({ active, duration = 3000 }) => {
  const [particles, setParticles] = useState([]);

  useEffect(() => {
    if (active) {
      const colors = ['#FF6B9D', '#C06EED', '#FFD700', '#00D9A5', '#4facfe', '#f5576c'];
      const newParticles = Array.from({ length: 50 }, (_, i) => ({
        id: i,
        left: Math.random() * 100,
        color: colors[Math.floor(Math.random() * colors.length)],
        delay: Math.random() * 0.5,
        size: 8 + Math.random() * 8,
        rotation: Math.random() * 360,
      }));
      setParticles(newParticles);

      const timer = setTimeout(() => setParticles([]), duration);
      return () => clearTimeout(timer);
    }
  }, [active, duration]);

  if (!active || particles.length === 0) return null;

  return (
    <div style={{ position: 'fixed', top: 0, left: 0, right: 0, bottom: 0, pointerEvents: 'none', zIndex: 9999, overflow: 'hidden' }}>
      {particles.map((p) => (
        <div
          key={p.id}
          style={{
            position: 'absolute',
            left: `${p.left}%`,
            top: '-20px',
            width: `${p.size}px`,
            height: `${p.size}px`,
            background: p.color,
            borderRadius: p.id % 2 === 0 ? '50%' : '2px',
            transform: `rotate(${p.rotation}deg)`,
            animation: `confettiFall 3s ease-out ${p.delay}s forwards`,
          }}
        />
      ))}
    </div>
  );
};

// 💕 قلوب طائرة عند الإعجاب
export const FlyingHearts = ({ trigger }) => {
  const [hearts, setHearts] = useState([]);

  useEffect(() => {
    if (trigger) {
      const newHearts = Array.from({ length: 8 }, (_, i) => ({
        id: Date.now() + i,
        left: 40 + Math.random() * 20,
        delay: Math.random() * 0.3,
        size: 16 + Math.random() * 12,
      }));
      setHearts(prev => [...prev, ...newHearts]);

      setTimeout(() => {
        setHearts(prev => prev.filter(h => !newHearts.find(nh => nh.id === h.id)));
      }, 2000);
    }
  }, [trigger]);

  return (
    <div style={{ position: 'fixed', bottom: '20%', left: 0, right: 0, pointerEvents: 'none', zIndex: 9998 }}>
      {hearts.map((h) => (
        <div
          key={h.id}
          style={{
            position: 'absolute',
            left: `${h.left}%`,
            bottom: 0,
            fontSize: `${h.size}px`,
            animation: `floatUp 2s ease-out ${h.delay}s forwards`,
            opacity: 0,
          }}
        >
          💕
        </div>
      ))}
      <style>{`
        @keyframes floatUp {
          0% { transform: translateY(0) scale(0); opacity: 0; }
          20% { opacity: 1; transform: translateY(-20px) scale(1); }
          100% { transform: translateY(-200px) scale(0.5); opacity: 0; }
        }
      `}</style>
    </div>
  );
};

// ✨ رسائل تحفيزية عشوائية
export const MotivationalToast = ({ show, onClose }) => {
  const messages = [
    { text: "قد يكون شريك حياتك على بعد نقرة واحدة! 💕", icon: "💝" },
    { text: "الزواج نصف الدين، أكمل نصفك معنا 🌙", icon: "🕌" },
    { text: "كل قصة حب تبدأ بخطوة، خذ خطوتك اليوم! 👣", icon: "💫" },
    { text: "أنت تستحق السعادة، ابحث عنها هنا 🌹", icon: "🎯" },
    { text: "الأرواح جنود مجندة، ما تعارف منها ائتلف 💞", icon: "✨" },
  ];

  const [message] = useState(() => messages[Math.floor(Math.random() * messages.length)]);

  useEffect(() => {
    if (show) {
      const timer = setTimeout(onClose, 5000);
      return () => clearTimeout(timer);
    }
  }, [show, onClose]);

  if (!show) return null;

  return (
    <div
      style={{
        position: 'fixed',
        bottom: '100px',
        left: '50%',
        transform: 'translateX(-50%)',
        background: 'linear-gradient(135deg, #667eea, #764ba2)',
        color: 'white',
        padding: '16px 24px',
        borderRadius: '16px',
        boxShadow: '0 10px 40px rgba(102, 126, 234, 0.4)',
        zIndex: 9997,
        animation: 'slideUp 0.5s ease',
        maxWidth: '90%',
        textAlign: 'center',
        direction: 'rtl',
      }}
    >
      <span style={{ fontSize: '24px', marginLeft: '10px' }}>{message.icon}</span>
      <span style={{ fontSize: '15px', fontWeight: '500' }}>{message.text}</span>
      <style>{`
        @keyframes slideUp {
          from { transform: translateX(-50%) translateY(100px); opacity: 0; }
          to { transform: translateX(-50%) translateY(0); opacity: 1; }
        }
      `}</style>
    </div>
  );
};

// 🌟 نجمة لامعة متحركة
export const SparkleEffect = ({ children }) => {
  return (
    <span style={{ position: 'relative', display: 'inline-block' }}>
      {children}
      <span style={{
        position: 'absolute',
        top: '-5px',
        right: '-5px',
        fontSize: '12px',
        animation: 'sparkle 1.5s ease-in-out infinite',
      }}>✨</span>
      <style>{`
        @keyframes sparkle {
          0%, 100% { opacity: 0; transform: scale(0.5) rotate(0deg); }
          50% { opacity: 1; transform: scale(1) rotate(180deg); }
        }
      `}</style>
    </span>
  );
};

// 📊 عداد متحرك للأرقام
export const AnimatedCounter = ({ end, duration = 2000, suffix = '' }) => {
  const [count, setCount] = useState(0);

  useEffect(() => {
    let startTime;
    const animate = (currentTime) => {
      if (!startTime) startTime = currentTime;
      const progress = Math.min((currentTime - startTime) / duration, 1);
      setCount(Math.floor(progress * end));
      if (progress < 1) {
        requestAnimationFrame(animate);
      }
    };
    requestAnimationFrame(animate);
  }, [end, duration]);

  return <span>{count.toLocaleString('ar-SA')}{suffix}</span>;
};

// 🎭 بطاقة ثلاثية الأبعاد
export const Card3D = ({ children, className, style }) => {
  const [transform, setTransform] = useState('');

  const handleMouseMove = (e) => {
    const rect = e.currentTarget.getBoundingClientRect();
    const x = e.clientX - rect.left;
    const y = e.clientY - rect.top;
    const centerX = rect.width / 2;
    const centerY = rect.height / 2;
    const rotateX = (y - centerY) / 20;
    const rotateY = (centerX - x) / 20;
    setTransform(`perspective(1000px) rotateX(${rotateX}deg) rotateY(${rotateY}deg) scale3d(1.02, 1.02, 1.02)`);
  };

  const handleMouseLeave = () => {
    setTransform('perspective(1000px) rotateX(0deg) rotateY(0deg) scale3d(1, 1, 1)');
  };

  return (
    <div
      className={className}
      style={{
        ...style,
        transform,
        transition: 'transform 0.3s ease',
        transformStyle: 'preserve-3d',
      }}
      onMouseMove={handleMouseMove}
      onMouseLeave={handleMouseLeave}
    >
      {children}
    </div>
  );
};

// 💬 فقاعة محادثة متحركة
export const ChatBubble = ({ message, isUser, animate = true }) => {
  return (
    <div
      style={{
        display: 'flex',
        justifyContent: isUser ? 'flex-end' : 'flex-start',
        marginBottom: '12px',
        animation: animate ? 'bubbleIn 0.3s ease' : 'none',
      }}
    >
      <div
        style={{
          maxWidth: '75%',
          padding: '12px 16px',
          borderRadius: isUser ? '18px 18px 4px 18px' : '18px 18px 18px 4px',
          background: isUser 
            ? 'linear-gradient(135deg, #FF6B9D, #C06EED)' 
            : 'var(--light-bg)',
          color: isUser ? 'white' : 'var(--text-dark)',
          boxShadow: '0 2px 10px rgba(0,0,0,0.1)',
        }}
      >
        {message}
      </div>
      <style>{`
        @keyframes bubbleIn {
          from { transform: scale(0.8); opacity: 0; }
          to { transform: scale(1); opacity: 1; }
        }
      `}</style>
    </div>
  );
};

// 🌈 خلفية متدرجة متحركة
export const AnimatedGradientBg = ({ children }) => {
  return (
    <div style={{ position: 'relative', overflow: 'hidden' }}>
      <div
        style={{
          position: 'absolute',
          top: 0,
          left: 0,
          right: 0,
          bottom: 0,
          background: 'linear-gradient(-45deg, #FF6B9D, #C06EED, #4facfe, #00f2fe, #00D9A5)',
          backgroundSize: '400% 400%',
          animation: 'gradientShift 15s ease infinite',
          opacity: 0.1,
          zIndex: 0,
        }}
      />
      <div style={{ position: 'relative', zIndex: 1 }}>{children}</div>
      <style>{`
        @keyframes gradientShift {
          0% { background-position: 0% 50%; }
          50% { background-position: 100% 50%; }
          100% { background-position: 0% 50%; }
        }
      `}</style>
    </div>
  );
};

export default {
  Confetti,
  FlyingHearts,
  MotivationalToast,
  SparkleEffect,
  AnimatedCounter,
  Card3D,
  ChatBubble,
  AnimatedGradientBg,
};
